import React, { ReactNode } from 'react';
import { ReactComponent as DeleteIcon } from 'Icons/CommandPanel/Delete_White.svg';
import { ReactComponent as EditIcon } from 'Icons/CommandPanel/Edit.svg';
import { ReactComponent as AddIcon } from 'Icons/PlusCircle.svg';
import { FmlxButton } from 'fmlx-common-ui';

interface Props extends React.InputHTMLAttributes<HTMLButtonElement> {
  iconName: string;
  iconStyle?: React.SVGProps<SVGSVGElement>;
  buttonStyle?: React.CSSProperties;
  onClick: () => void;
}

const getIcon = (
  iconName: string,
  iconStyle: React.SVGProps<SVGSVGElement>,
): ReactNode => {
  switch (iconName) {
    case 'delete':
      return (
        <DeleteIcon
          id="controls-imgbtn-del-icon"
          data-testid="controls-imgbtn-del-icon"
          color="white"
          {...iconStyle}
        />
      );
    case 'edit':
      return (
        <EditIcon
          id="controls-imgbtn-edit-icon"
          data-testid="controls-imgbtn-edit-icon"
          color="white"
          {...iconStyle}
          fontSize={80}
        />
      );
    case 'add':
      return (
        <AddIcon
          id="controls-imgbtn-add-icon"
          data-testid="controls-imgbtn-add-icon"
          color="white"
          {...iconStyle}
        />
      );
    case 'email':
      return (
        <div id="controls-imgbtn-@" data-testid="controls-imgbtn-@">
          @
        </div>
      );
  }
};

const ImageButton = (props: Props) => {
  const { iconName, iconStyle, onClick } = props;

  return (
    <FmlxButton
      id="controls-imgbtn-remove"
      data-testid="controls-imgbtn-remove"
      onClick={onClick}
      tooltipDescription="Remove"
      icon={getIcon(iconName, iconStyle)}
      onlyIcon={true}
    />
  );
};

export default ImageButton;
